import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex, Text, Input, Textarea } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const InputCell = ({
  getValue,
  table,
  row: { index: rowIndex },
  column: { id: columnId },
  type = 'text',
  extraDisable = false,
  handleChange = () => {},
  handlePaste = () => {},
  handleBlur = () => {},
}) => {
  const [localValue, setLocalValue] = useState(getValue() ?? '')
  const isDisabled = table.options.meta?.disabled || extraDisable

  useEffect(() => {
    if (getValue()) {
      setLocalValue(getValue)
    }
  }, [getValue])

  const onChange = ({ target: { value } }) => {
    setLocalValue(value)
    handleChange(value)
  }
  const onPaste = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData
    const pastedData = clipboardData.getData('Text')

    e.preventDefault()
    e.stopPropagation()

    handlePaste(pastedData, { rowIndex, columnId })
  }

  const onBlur = () => {
    table.options.meta?.updateData(rowIndex, columnId, localValue)

    handleBlur(localValue)
  }

  if (isDisabled) {
    return <Text>{localValue}</Text>
  }
  return <Input type={type} value={localValue} onChange={onChange} onBlur={onBlur} onPaste={onPaste}></Input>
}

export default InputCell
